export default "__VITE_ASSET__kTXbGZsn__"